import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "web-editor" }
const _hoisted_2 = { class: "edit-draft" }
const _hoisted_3 = { class: "editor-header" }
const _hoisted_4 = { class: "right-box" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "md-editor" }
const _hoisted_7 = {
  key: 0,
  class: "el-upload-list el-upload-list--picture-card"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "el-upload-list__item-actions" }

import { markRaw, reactive, ref, onMounted,computed } from "vue";
import type { FormInstance, FormRules, UploadProps } from "element-plus";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import axiosInstance from "@/utils/axiosInstance";
import FileStorageInstance from "@/utils/axiosFileStorage";
import { FileStorage_URL } from "@/interface/globalindex";
import { v4 as uuidv4 } from 'uuid';
import "bytemd/dist/index.css";
import { Editor } from "@bytemd/vue-next";
//支持GFM(自动链接文字、删除、表格、任务列表)
import gfm from "@bytemd/plugin-gfm";
// 突出显示代码块
import highlight from "@bytemd/plugin-highlight";
import "highlight.js/styles/default.css";

// 对齐方式
import alignPlugin from "bytemd-plugin-align";
// 主题
import theme from "bytemd-plugin-theme";
// 解析前言 格式化
import frontmatter from "@bytemd/plugin-frontmatter";
// 表情
import gemoji from "@bytemd/plugin-gemoji";

// 代码高亮
import highLightPlugin from "bytemd-plugin-highlight";
// 图片的缩放
import imagePlugin from "bytemd-plugin-image";
// 代码复制
// import copyCode from "bytemd-plugin-copy-code";
// 缩放图片 点击图片放大,再点击缩小
import mediumZoom from "@bytemd/plugin-medium-zoom";
// 图表
import mermaid from "@bytemd/plugin-mermaid";
import mermaidLocale from "@bytemd/plugin-mermaid/locales/zh_Hans.json";
// 数学公式插件
import math from "@bytemd/plugin-math";
import mathLocale from "@bytemd/plugin-math/locales/zh_Hans.json";
import "katex/dist/katex.css";

import zhHans from "bytemd/locales/zh_Hans.json";

import { useOAuthStore } from '@/stores/oauth'
const formLabelWidth = "83px";

//插件列表
interface RuleForm {
  article_id: string;
  title: string;
  info_content: string;
  category_id: string;
  cover_image: string;
  brief_content: string;
  link_url: string;
  picurls: string[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EditorDrafts',
  setup(__props) {

const authStore = useOAuthStore()
const token = authStore.token
// 计算属性生成带 token 的 headers
const UpLoadHeaders = computed(() => ({
  Authorization: `Bearer ${token}` // 根据实际存储方式调整
}));

const router = useRouter();
const pluginsList = [
  gfm(),
  math({
    locale: mathLocale,
  }),
  alignPlugin(),
  highLightPlugin(),
  imagePlugin(),
  // copyCode(),
  mediumZoom(),
  mermaid({
    locale: mermaidLocale,
  }),
  highlight(),
  theme(),
  frontmatter(),
  gemoji()

];

//编辑器参数
const editorstate = reactive({
  value: "",
  plugins: markRaw(pluginsList),
  zh: zhHans,
  dialogFormVisible: ref(false),
  postID: "",
});

// 获取文章数据
const fetchArticleEditData = async (postID: string) => {
  try {
    await axiosInstance
      .get("/api/ArticleInfo/GetArticleInfoDetail", {
        params: {article_id:postID},
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
            const articleData = result.data;
            //已发布的草稿箱
            if (articleData.article_id) {
              form.article_id = articleData.article_id;
              editorstate.postID = articleData.article_id;
              drafts.status = 2;
              drafts.drafts_id = articleData.drafts_id;
            }
            else{
              //草稿箱
              editorstate.postID = generateGUID();
              uploadCoverData.articleId = editorstate.postID;
              drafts.drafts_id = articleData.drafts_id;
            }
            form.title = articleData.title;
            form.info_content = articleData.info_content;
            form.category_id = articleData.category_id;
            form.cover_image = articleData.cover_image;
            form.brief_content = articleData.brief_content;
            form.link_url = articleData.link_url;
            editorstate.value = articleData.info_content;
            if (articleData.cover_image) {
              imageInfo.imageUrl = articleData.cover_image;
              imageInfo.imageVisible = true;
            }

            
        }
      });
  } catch (error) {
    ElMessage.error("获取文章数据失败");
  }
};

//生成GUID
const generateGUID = () => uuidv4();

onMounted(() => {
  getCategory();
  //获取文章ID 参数
  const postID = router.currentRoute.value.params.postID as string;
  if (postID) {
    fetchArticleEditData(postID);
  } else {
    router.push({ path: "/creator/article" });
  }
});

//分类
const state = reactive({
  categorylistData: [], // 数据列表
});

// 获取分类列表
const getCategory = () => {
  axiosInstance
    .get("/api/ArticleInfo/GetCategoryList", {
      params: {},
    })
    .then((res) => {
      var result = res.data;
      if (result.success) {
        state.categorylistData = result.data;
      }
    });
};

const ruleFormRef = ref<FormInstance>();

const form = reactive<RuleForm>({
  article_id: "",
  title: "",
  info_content: "",
  category_id: "",
  cover_image: "",
  brief_content: "",
  picurls: [],
  link_url: "",
});

//事件 自动保存草稿箱
const handleChange = (v: string) => {
  editorstate.value = v;
  form.info_content = editorstate.value;
  AutoCreateDrafts();
};
//封面地址
const imageInfo = reactive({
  imageVisible: false,
  imageUrl: "",
});

//封面上传额外参数
const uploadCoverData = reactive({
  articleId: editorstate.postID,
  uploadactionurl: FileStorage_URL + "/api/ArticleInfo/UploadCoverImage",
});

//封面上传成功回调函数
const handleAvatarSuccess: UploadProps["onSuccess"] = (response) => {
  if (response.success) {
    imageInfo.imageUrl = response.data;
    imageInfo.imageVisible = true;
    form.cover_image = response.data;
  }
};

//移除封面
const handleRemove = () => {
  imageInfo.imageVisible = false;
  imageInfo.imageUrl = "";
  form.cover_image = "";
};

//封面格式大小限制
const beforeAvatarUpload: UploadProps["beforeUpload"] = (rawFile) => {
  if (rawFile.type !== "image/jpeg") {
    ElMessage.error("Avatar picture must be image format!");
    return false;
  } else if (rawFile.size / 1024 / 1024 > 15) {
    ElMessage.error("Avatar picture size can not exceed 15MB!");
    return false;
  }
  return true;
};

//编辑器上传图片
const handleUploadFile = async (files) => {
  let fileData = new FormData();
  //多图片上传
  for (let i = 0; i < files.length; i++) {
    fileData.append("files", files[i]);
  }
  fileData.append("articleId", editorstate.postID);
  await FileStorageInstance
    .post("api/ArticleInfo/UploadArticleImage", fileData, {
      headers: { "content-Type": "multipart/form-data" },
    })
    .then((res) => {
      var result = res.data;
      if (result.success) {
        form.picurls = result.data;
      }
    });
  return form.picurls;
};

//发布
const publishBtn = () => {
  if (form.title === "") {
    ElMessage.error("请输入文章标题");
    return;
  }
  if (form.info_content === "") {
    ElMessage.error("请输入文章内容");
    return;
  }
  editorstate.dialogFormVisible = true;
};
const rules = reactive<FormRules<RuleForm>>({
  category_id: [{ required: true, message: "请选择一个分类", trigger: "blur" }],
  brief_content: [
    { required: true, message: "摘要不满足最低50字的要求", trigger: "blur" },
    { min: 50, max: 100, message: "摘要不满足最低50字的要求", trigger: "blur" },
  ],
});

//发布文章
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      let params = {
        article_id: editorstate.postID,
        title: form.title,
        info_content: form.info_content,
        category_id: form.category_id,
        brief_content: form.brief_content,
        link_url: form.link_url,
        cover_image: form.cover_image,
        drafts_id: drafts.drafts_id,
      };

      axiosInstance
        .post("api/ArticleInfo/ArticleInfoSave", params)
        .then((res) => {
          var result = res.data;
          if (result.success) {
            router.push({ path: "/published" });
          }
        });
    } else {
      console.log("error submit!");
    }
  });
};

//草稿箱参数
const drafts = reactive({
  drafts_id: "",
  title: "",
  info_content: "",
  category_id: "",
  cover_image: "",
  brief_content: "",
  status: 1,
  resulttext: "文章将自动保存至草稿箱",
  resulttitle: "",
  resultupdatetime: "",
});

//自动保存草稿箱
const AutoCreateDrafts = () => {
  let postdata = {
    drafts_id: drafts.drafts_id,
    title: form.title,
    info_content: form.info_content,
    category_id: form.category_id,
    brief_content: form.brief_content,
    link_url: form.link_url,
    cover_image: form.cover_image,
    status: drafts.status,
    article_id:form.article_id
  };
  drafts.resulttext = "保存中...";
  axiosInstance
    .post("api/ArticleDrafts/ArticleDraftsSave", postdata)
    .then((res) => {
      var result = res.data;
      if (result.success) {
        drafts.drafts_id = result.data.drafts_id;
        drafts.resultupdatetime = "最近保存于 " + result.data.updated_at;
        drafts.resulttext = "保存成功";
      }
    });
};

//点击草稿箱 关闭窗口
const closeWindow = () => {
  window.close();
};

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "输入文章标题...",
            spellcheck: "false",
            maxlength: "80",
            class: "title-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
            onInput: AutoCreateDrafts
          }, null, 544), [
            [_vModelText, form.title]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "topic-icon" }, null, -1)),
            _createElementVNode("div", {
              title: drafts.resultupdatetime,
              class: "status-text with-padding"
            }, _toDisplayString(drafts.resulttext), 9, _hoisted_5),
            _createElementVNode("button", {
              class: "btn-drafts",
              onClick: closeWindow
            }, " 草稿箱 "),
            _createElementVNode("div", { class: "with-padding" }, [
              _createElementVNode("button", {
                class: "publish-btn",
                onClick: publishBtn
              }, " 发布 ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Editor), {
          value: editorstate.value,
          locale: editorstate.zh,
          "upload-images": handleUploadFile,
          plugins: editorstate.plugins,
          onChange: handleChange
        }, null, 8, ["value", "locale", "plugins"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: editorstate.dialogFormVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editorstate.dialogFormVisible) = $event)),
      title: "发布文章",
      width: "580"
    }, {
      default: _withCtx(() => [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "plusdivider" }, null, -1)),
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: form,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "分类",
              "label-width": formLabelWidth,
              prop: "category_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.category_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.category_id) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.categorylistData, (category) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: category.category_id,
                        value: category.category_id,
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.category_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "文章封面",
              "label-width": formLabelWidth,
              prop: "cover_image"
            }, {
              default: _withCtx(() => [
                (imageInfo.imageVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("img", {
                        class: "el-upload-list__item-thumbnail",
                        src: imageInfo.imageUrl,
                        alt: ""
                      }, null, 8, _hoisted_8),
                      _createElementVNode("span", _hoisted_9, [
                        _createElementVNode("span", {
                          class: "el-upload-list__item-delete",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleRemove()))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!imageInfo.imageVisible)
                  ? (_openBlock(), _createBlock(_component_el_upload, {
                      key: 1,
                      class: "avatar-uploader",
                      action: uploadCoverData.uploadactionurl,
                      headers: UpLoadHeaders.value,
                      method: "POST",
                      name: "myIfile",
                      data: uploadCoverData,
                      "show-file-list": false,
                      "on-success": handleAvatarSuccess,
                      "before-upload": beforeAvatarUpload
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "upload-text" }, "上传封面", -1))
                      ]),
                      _: 1
                    }, 8, ["action", "headers", "data"]))
                  : _createCommentVNode("", true),
                _cache[9] || (_cache[9] = _createElementVNode("div", null, "建议尺寸：192*128px (封面仅展示在首页信息流中)", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "编辑摘要",
              "label-width": formLabelWidth,
              prop: "brief_content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.brief_content,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.brief_content) = $event)),
                  maxlength: "100",
                  style: {"width":"400px"},
                  rows: "4",
                  placeholder: "",
                  "show-word-limit": "",
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "button-group-right" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode(" 确定并发布 ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (editorstate.dialogFormVisible = false))
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("取消")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})